import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoutUser from '../../api/logoutUser';
import { useGetUser, useSetUser } from '../../context/userContext';

const MainMenu = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const user = useGetUser();
  const setUser = useSetUser();

  useEffect(() => {
    const body = document.getElementById('body');
    if (!body) return;

    if (openMenu) {
      body.classList.add('menu-sm');
    } else {
      body.classList.remove('menu-sm');
    }
  }, [openMenu]);

  const handleLogout = () => {
    setOpenMenu(false);
    logoutUser(setUser);
  };

  return (
    <>
      <div className="items">
        <Link to="/" className="item d-none d-lg-flex" onClick={() => setOpenMenu(false)}>
          IT solutions
        </Link>
        <Link to="/" className="item d-none d-lg-flex" onClick={() => setOpenMenu(false)}>
          Services
        </Link>
        <Link to="/" className="item d-none d-lg-flex" onClick={() => setOpenMenu(false)}>
          Careers
        </Link>
        <Link to="/" className="item d-none d-lg-flex" onClick={() => setOpenMenu(false)}>
          About us
        </Link>
        <Link to="/" className="item d-none d-lg-flex" onClick={() => setOpenMenu(false)}>
          Latest news
        </Link>
        <Link to="/" className="item d-none d-lg-flex" onClick={() => setOpenMenu(false)}>
          Contact
        </Link>
        <div className="btn-group item d-none d-lg-flex">
          <button type="button" className="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            My profile
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            {user && (
              <li>
                <Link to="/profile" className="dropdown-item" onClick={() => setOpenMenu(false)}>
                  View my profile
                </Link>
              </li>
            )}
            {!user && (
              <li>
                <Link to="/login" className="dropdown-item" onClick={() => setOpenMenu(false)}>
                  Login
                </Link>
              </li>
            )}
            {user && (
              <li>
                <Link to="/" className="dropdown-item" onClick={handleLogout}>
                  Logout
                </Link>
              </li>
            )}
          </ul>
        </div>
        <Link to="/" className="item d-lg-none hamburger" onClick={() => setOpenMenu((prev) => !prev)}>
          <i className="bi bi-list"></i>
        </Link>
        <Link to="/" className="item d-none close" onClick={() => setOpenMenu((prev) => !prev)}>
          <i className="bi bi-x-lg"></i>
        </Link>
      </div>
    </>
  );
};

export default MainMenu;
